import React from "react";
import PropTypes from "prop-types";
import {
  TableRow,
  TableCell,
  Collapse,
  Divider,
  Grid,
  makeStyles,
  Box,
  Chip,
  Paper,
} from "@material-ui/core";
import translate from "i18n/translate";
import ChipCell from "./ChipCell";
import DetailTable from "./DetailTable";
import { DISTRIBUTOR_TYPE } from "../constants";

import { Typography } from "../../../../common";

export const useStyles = makeStyles((theme) => ({
  expandableRowClosed: {
    border: "none",
    padding: 0,
  },
  expandableRow: {
    padding: 0,
  },
  item: {
    margin: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
  },
  selectable: {
    cursor: "pointer",
  },
}));

const ExpandableRow = ({ isOpen, data, onClose, type }) => {
  const classes = useStyles();
  const expandableRowData = data.expandableRow;

  return (
    <TableRow>
      <TableCell
        colSpan={type === DISTRIBUTOR_TYPE.master ? 8 : 5}
        className={isOpen ? classes.expandableRow : classes.expandableRowClosed}
      >
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <Paper elevation={2} square>
            <Grid container direction="row">
              <Grid item xs={3}>
                <Box
                  display="flex"
                  direction="column"
                  height="100%"
                  flexGrow="1"
                >
                  <Box flexGrow="1">
                    <Box
                      onClick={onClose}
                      className={classes.selectable}
                      overflow="hidden"
                    >
                      <Box margin={2}>
                        <ChipCell
                          warning
                          chipValue={data.referal.outcost}
                          value={data.referal.name}
                        />
                      </Box>
                    </Box>
                    <Divider />
                    <div className={classes.item}>
                      <Typography variant="tableBody1" component="span">
                        {expandableRowData.username}
                      </Typography>
                    </div>
                    <Divider />
                    <div className={classes.item}>
                      <Typography variant="tableBody1SemiBold" component="span">
                        {translate("distributors.phone")}
                      </Typography>
                      <Typography variant="tableBody1" component="span">
                        {expandableRowData.phone}
                      </Typography>
                    </div>
                    <Divider />
                    <div className={classes.item}>
                      <Typography variant="tableBody1SemiBold" component="span">
                        {translate("distributors.registredDate")}
                      </Typography>
                      <Typography variant="tableBody1" component="span">
                        {expandableRowData.applyDate}
                      </Typography>
                    </div>
                    <Divider />
                    <Box
                      display="flex"
                      flexGrow="1"
                      justifyContent="space-between"
                      className={classes.item}
                    >
                      <div>
                        <Typography
                          variant="tableBody1SemiBold"
                          component="span"
                        >
                          {translate("distributors.referals")}
                        </Typography>
                        <Typography variant="tableBody1" component="span">
                          {expandableRowData.referals}
                        </Typography>
                      </div>
                      <Chip
                        size="small"
                        color="primary"
                        label={data.operations.distributorCode}
                      />
                    </Box>
                  </Box>
                  <div>
                    <Divider orientation="vertical" />
                  </div>
                </Box>
              </Grid>
              <Grid item xs={9}>
                <DetailTable
                  detailData={expandableRowData}
                  onClose={onClose}
                  type={type}
                />
              </Grid>
            </Grid>
          </Paper>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

ExpandableRow.propTypes = {
  data: PropTypes.shape({}),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

ExpandableRow.defaultProps = {
  data: {},
  isOpen: false,
};

export default ExpandableRow;
